/**
 * @copyright © Paramount Streaming
 * @description Skin UI mode — toggles the active overlay between the normal player chrome
 * and the minimal Mini Player chrome. Driven by `tag.API.TAG.uiMode()`; owned/dispatched
 * through TagEvent.ON_UI_MODE_CHANGE_REQUEST / ON_UI_MODE_CHANGE_DONE.
 *
 * Exposed publicly via `SmartTag.enums.UIMode`.
 */
export enum UIMode {

	/**
	 * @description Mini overlay — centered Jump-to-Video, top-right ad countdown ring,
	 * bottom-right mute. ControlsManager and normal-skin chrome hidden.
	 */
	MINI = 'mini',

	/**
	 * @description Normal overlay — full ControlsManager chrome. Default mode.
	 */
	NORMAL = 'normal',

	/**
	 * @description Theatre mode — in-page, edge-to-edge player. The host performs the resize +
	 * scroll lock and persists the preference; Smart Tag keeps full chrome and only reflects the
	 * theatre button's active state. Requested by the host via `tag.API.TAG.uiMode(UIMode.THEATRE)`
	 * after the skin surfaces `SkinEvent.ON_THEATRE_MODE_REQUESTED`.
	 */
	THEATRE = 'theatre'

}